import { inject } from '@angular/core';
import { Router, ResolveEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

/**
 * Custom TitleStrategy that reads the page title from route data
 * and updates the browser title accordingly.
 */
export class KreadorTitleStrategy {
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly titleTemplate = 'Kreador — AI-Powered Business Suite for Growing Businesses';

  constructor() {
    this.initTitleListener();
  }

  private initTitleListener(): void {
    this.router.events
      .pipe(filter((event): event is ResolveEnd => event instanceof ResolveEnd))
      .subscribe(() => {
        const route = this.router.routerState.snapshot.root;
        const pageTitle = this.getTitleFromRouteData(route);
        
        if (pageTitle) {
          this.title.setTitle(`${pageTitle} | Kreador`);
        } else {
          this.title.setTitle(this.titleTemplate);
        }
      });
  }

  private getTitleFromRouteData(route: { data?: { title?: string }, children?: any[] } | null): string | null {
    if (!route) return null;
    
    // First check the current route's data
    if (route.data && route.data['title']) {
      return route.data['title'];
    }

    // If no title found, check child routes
    if (route.children && route.children.length > 0) {
      for (const child of route.children) {
        const childTitle = this.getTitleFromRouteData(child);
        if (childTitle) {
          return childTitle;
        }
      }
    }

    return null;
  }
}